module.exports = __webpack_public_path__ + "b59ed445e1c32a2b47d2d9b4c025f969.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/jam-pad-empty.png
// module id = 322
// module chunks = 0